export default "__VITE_ASSET__BvGEki0H__"